module.exports = __webpack_public_path__ + "img/3.c8ff62c4.jpg";